"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Answer =
/*#__PURE__*/
function (_Component) {
  _inherits(Answer, _Component);

  function Answer(props) {
    var _this;

    _classCallCheck(this, Answer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Answer).call(this, props));
    _this.state = {};
    return _this;
  }

  _createClass(Answer, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          userAnswers = _this$props.userAnswers,
          answers = _this$props.answers,
          questionType = _this$props.questionType,
          renderInResult = _this$props.renderInResult,
          correctAns = _this$props.correctAns,
          qIdx = _this$props.qIdx;
      var answerKey = ["A", "B", "C", "D"];
      var renderAnswer = answers.map(function (answer, index) {
        var value = answerKey[index] + ". " + answer;
        return questionType == 'text' && _react.default.createElement("button", {
          className: "btn-large",
          key: index,
          "data-value": answer,
          onClick: function onClick() {
            return _this2.props.handleClick(index);
          }
        }, value) || questionType == 'photo' && _react.default.createElement("button", null, _react.default.createElement("img", {
          key: index,
          alt: "",
          src: answer,
          onClick: function onClick() {
            return _this2.props.handleClick(index);
          }
        }));
      });
      var renderAnswerInResult = renderInResult && answers.map(function (answer, index) {
        var c = "";

        if (index + 1 == correctAns[qIdx]) {
          c = "btn-success";
        } else if (index + 1 == userAnswers[qIdx] && correctAns[qIdx] != userAnswers[qIdx]) {
          c = "btn-danger";
        }

        var value = answerKey[index] + ". " + answer;
        return questionType == 'text' && _react.default.createElement("button", {
          className: "".concat(c, " btn-large"),
          key: index,
          "data-value": answer
        }, value) || questionType == 'photo' && _react.default.createElement("button", {
          className: "".concat(c, " img-answer")
        }, _react.default.createElement("img", {
          key: index,
          alt: "",
          src: answer
        }));
      });
      return _react.default.createElement("div", {
        className: "answer-container"
      }, renderInResult == true ? _react.default.createElement("div", {
        className: "result-answer"
      }, renderAnswerInResult) : _react.default.createElement("div", null, renderAnswer));
    }
  }]);

  return Answer;
}(_react.Component);

Answer.propTypes = {
  userAnswers: _propTypes.default.array,
  answers: _propTypes.default.array,
  questionType: _propTypes.default.string,
  renderInResult: _propTypes.default.bool,
  correctAns: _propTypes.default.array,
  qIdx: _propTypes.default.number,
  handleClick: _propTypes.default.func
};
var _default = Answer;
exports.default = _default;